<template>
    <b-modal size="lg"
             centered
             hide-footer
             v-bind:visible="value"
             v-on:hide="hideModal"
             v-on:cancel="hideModal"
             v-on:close="hideModal">
        <template v-slot:modal-title>
            <strong>
                <span v-if="!isEditing">新增分類</span>
                <span v-else>編輯分類《{{ category.name }}》中</span>
            </strong>
        </template>

        <b-form v-on:submit.prevent="submit"
                v-on:reset="reset">
            <div class="form-row">
                <b-form-group class="col-12"
                              label="分類名稱"
                              label-for="name">
                    <b-form-input id="name"
                                  name="name"
                                  type="text"
                                  required
                                  v-model="name">
                    </b-form-input>
                </b-form-group>

                <b-form-group class="col-12"
                              label="分類顏色"
                              label-for="color">
                    <swatches id="color"
                              inline
                              v-bind:color="['basic', 'material-basic']"
                              v-model="color">
                    </swatches>
                </b-form-group>
            </div>

            <div class="d-flex justify-content-between">
                <button type="reset"
                        class="btn btn-secondary"
                        v-bind:class="{ 'btn-loading': isLoading }">
                    重設
                </button>

                <button type="submit"
                        class="btn btn-primary"
                        v-bind:class="{ 'btn-loading': isLoading }">
                    儲存
                </button>
            </div>
        </b-form>
    </b-modal>
</template>

<script>
    import {
        BModal,
        BForm,
        BFormGroup,
        BFormInput,
    } from "bootstrap-vue";

    import Swatches from "vue-swatches";

    export default {
        name: "ModalCategory",
        components: {
            BModal,
            BForm,
            BFormGroup,
            BFormInput,
            Swatches,
        },
        props: {
            "value": {
                type: Boolean,
                default: false,
            },

            "type": {
                type: String,
                enum: ["vending",],
                default: "vending",
            },

            "isEditing": {
                type: Boolean,
                default: false,
            },

            "category": {
                type: Object,
            },
        },
        data () {
            return {
                isLoading: false,

                name: "",
                color: null,
            };
        },
        computed: {
            allowSave () {
                return this.name && this.color;
            },
        },
        methods: {
            hideModal () {
                this.$emit("input", false);
            },

            submit () {
                if (!this.allowSave) {
                    return;
                }

                if (this.isEditing) {
                    this.editCategory();
                } else {
                    this.addCategory();
                }
            },

            async addCategory () {
                this.isLoading = true;
                try {
                    await this.$store.dispatch(
                        "data/addCategory",
                        {
                            "type": this.type,
                            "name": this.name,
                            "color": this.color,
                        }
                    );
                } catch (e) {
                    console.error(e);
                    this.isLoading = false;
                    return;
                }
                this.isLoading = false;
                this.$emit("input", false);
                this.reset();
            },

            async editCategory () {
                this.isLoading = true;
                try {
                    await this.$store.dispatch(
                        "data/editCategory",
                        {
                            "_id": this.category._id,
                            "type": this.type,
                            "name": this.name,
                            "color": this.color,
                        }
                    );
                } catch (e) {
                    console.error(e);
                    this.isLoading = false;
                    return;
                }
                this.isLoading = false;
                this.$emit("input", false);
                this.reset();
            },

            reset () {
                this.name = "";
                this.color = "";
            },
        },
        mounted () {
            if (this.category) {
                const {
                    name,
                    color,
                } = this.category;

                this.name = name;
                this.color = color;
            }
        },
        watch: {
            "category" (newVal) {
                if (newVal) {
                    const {
                        name,
                        color,
                    } = newVal;

                    this.name = name;
                    this.color = color;
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>
